module.exports = __webpack_public_path__ + "img/dev_tool_request_response.821184ac.png";